import { useEffect, useState, useContext } from 'react';
import { useForm } from "react-hook-form";

import * as Regex from 'utils/validations';
import { DataContext } from 'providers/data';
import { DataTypesOfContact } from 'core/typesOfContact';
import { ParamsDataCustomerForEdit } from 'utils/typeServices';

import { Box, Typography, Collapse } from '@mui/material';

import Modals from 'components/views/Modals';
import Input from 'components/views/form/Input';
import Select from 'components/views/form/Select';
import { ButtonOutlined, ButtonRectangle } from 'components/views/form/Button';

import { ReactComponent as IcDeleteOutlined } from 'assets/icons/ic-delete-outlined.svg';

type ParamsCustomerForEdit = {
    dataCustomerForEdit: ParamsDataCustomerForEdit;
}

const EmergencyContact = ({ dataCustomerForEdit }: ParamsCustomerForEdit) => {
    const { register, setValue, watch, handleSubmit, formState: { errors } } = useForm();
    const [isLoading, setIsLoading] = useState(false);
    const [addContact, setAddContact] = useState(false);
    const [isEditInfos, setIsEditInfos] = useState(false);
    const [isEnableBtn, setIsEnableBtn] = useState(false);
    const [showAddEmergencyContact, setShowAddEmergencyContact] = useState(false);
    const [showModalDeleted, setShowModalDeleted] = useState({
        show: false,
        indexDeleted: 0
    });

    const { dataRelationship, updatePerfil, handleGetRelationship, handlePostEditCustomerAppEmergencyContacts } = useContext(DataContext);

    const [typeSelected, setTypeSelected] = useState({
        text: '',
        value: ''
    });

    const [relationshipSelected, setRelationshipSelected] = useState({
        text: '',
        value: ''
    });

    const nameAdd = watch('nameAdd', '');
    const phoneAdd = watch('phoneAdd', '');

    const handleCheckType = (type: number) => {
        switch (type) {
            case 1:
                return {
                    text: 'COMERCIAL',
                    value: 1
                }
            case 2:
                return {
                    text: 'RESIDENCIAL',
                    value: 2
                }
            case 3:
                return {
                    text: 'CELULAR',
                    value: 3
                }
            case 7:
                return {
                    text: 'WHATSAPP',
                    value: 7
                }
        }
    }

    const onSubmit = () => {
        handlePostEditCustomerAppEmergencyContactsState();
    }

    const handlePostEditCustomerAppEmergencyContactsState = () => {
        setIsLoading(true);

        let emergencyListAux = dataCustomerForEdit.emergencyList.map(({ customerPhoneId }, index) => {
            return {
                customerPhoneId,
                contact: watch(`name${index}`),
                degreeRelationship: parseFloat(watch(`typeContact${index}[value]`)),
                number: watch(`phone${index}`).replace(/[^0-9]/g, '').slice(2, 20),
                phoneDDD: watch(`phone${index}`).replace(/[^0-9]/g, '').slice(0, 2),
                phoneTypeId: parseFloat(watch(`typePhone${index}[value]`)),
                deleted: watch(`deleted${index}`)
            };
        })

        addContact && emergencyListAux.push({
            customerPhoneId: 0,
            contact: nameAdd,
            degreeRelationship: parseFloat(relationshipSelected?.value),
            number: phoneAdd.replace(/[^0-9]/g, '').slice(2, 20),
            phoneDDD: phoneAdd.replace(/[^0-9]/g, '').slice(0, 2),
            phoneTypeId: parseFloat(typeSelected?.value),
            deleted: false,
        });

        handlePostEditCustomerAppEmergencyContacts({
            token: localStorage.getItem('token')!,
            body: {
                id: dataCustomerForEdit.id,
                emergencyList: emergencyListAux
            }
        });
    }

    const handleSelectedRelationShipt = (idRelationShipt: number) => {
        const selected = dataRelationship?.find(({ CD_GRAU_RELACIONAMENTO }) => CD_GRAU_RELACIONAMENTO === idRelationShipt);

        return { text: selected?.NM_GRAU_RELACIONAMENTO, value: `${selected?.CD_GRAU_RELACIONAMENTO}` }
    }

    const handlePlaceholderPhone = (typePhone: number) => {
        if ((typePhone === 3) || (typePhone === 7)) {
            return '(99) 99999-9999';
        } else {
            return '(99) 9999-9999';
        }
    }

    const handleCancelOperation = () => {
        setAddContact(false);
        setIsEditInfos(!isEditInfos);

        if (isEditInfos) {
            handleFillInputs();
            setShowAddEmergencyContact(true);

            setTimeout(() => {
                setShowAddEmergencyContact(false);
            }, 550);
        }
    }

    const handleFillInputs = () => {
        !dataRelationship && handleGetRelationship({ token: localStorage.getItem('token')! });

        dataRelationship &&
            dataCustomerForEdit.emergencyList.map(({ contact, phoneDDD, number, phoneTypeId, deleted, degreeRelationship }, index) => (
                // eslint-disable-next-line no-sequences
                setValue(`name${index}`, contact),
                setValue(`phone${index}`, phoneTypeId === 3 ? `(${phoneDDD}) ${number.slice(0, 5)}-${number.slice(5, 9)}` : `(${phoneDDD}) ${number.slice(0, 4)}-${number.slice(4, 8)}`),
                setValue(`typePhone${index}`, handleCheckType(phoneTypeId)),
                setValue(`typeContact${index}`, handleSelectedRelationShipt(degreeRelationship)),
                setValue(`deleted${index}`, deleted)
            ));
        setIsLoading(false);
        setAddContact(false);
        setIsEditInfos(false);
    }

    useEffect(() => {
        if (dataCustomerForEdit) {
            handleFillInputs();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [dataCustomerForEdit, dataRelationship]);

    useEffect(() => {
        setTimeout(() => {
            setShowAddEmergencyContact(addContact);
        }, 550);
        setValue('nameAdd', '');
        setValue('phoneAdd', '');
        setTypeSelected({ text: '', value: '' });
        setRelationshipSelected({ text: '', value: '' });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [addContact]);

    useEffect(() => {
        if (addContact && phoneAdd && nameAdd && typeSelected?.value && relationshipSelected?.value) {
            setIsEnableBtn(false);
        } else if (addContact) {
            setIsEnableBtn(true);
        } else {
            setIsEnableBtn(false);
        }
    }, [addContact, phoneAdd, nameAdd, typeSelected.value, relationshipSelected.value]);

    useEffect(() => {
        if (updatePerfil?.type !== 'default') {
            setIsLoading(false);
            setAddContact(false);
            setIsEditInfos(false);
        }
    }, [updatePerfil]);

    return (
        <Box sx={{ width: '100%' }}>
            <Collapse in={addContact ? showAddEmergencyContact : addContact}>
                <Typography fontWeight={600} fontSize='1.25rem' marginBottom='1.06rem' color='primary.light'>
                    Novo contato:
                </Typography>
            </Collapse>

            <Collapse in={addContact ? showAddEmergencyContact : addContact}>
                <Box sx={{ borderTop: `${!addContact ? '2px solid #0C1C33' : ''}`, maxWidth: '35.43rem', '#box-input': { height: '4.125rem' } }}>
                    <Box sx={{ display: 'flex', flexDirection: 'column', gap: '1.75rem', marginBottom: '1.75rem' }}>
                        <Input
                            name='nameAdd'
                            label='Nome'
                            placeholder='Nome do Contato'
                            type='text'
                            disabled={!isEditInfos}
                            register={{ ...register("nameAdd", { pattern: Regex.name }) }} />
                        <Box sx={{ display: 'flex', alignItems: 'flex-end', justifyContent: 'space-between', gap: '1rem' }}>
                            <Select
                                label='Tipo'
                                disabled={!isEditInfos}
                                itemSelected={typeSelected}
                                listItems={DataTypesOfContact.map(({ phoneTypeText, phoneTypeId }) => {
                                    return { text: phoneTypeText, value: `${phoneTypeId}` }
                                })}
                                onChangeSelected={(e) => setTypeSelected(e)}
                            />
                            <Input
                                name='phoneAdd'
                                label='Telefone'
                                placeholder={typeSelected.value === '3' ? '(99) 99999-9999' : '(99) 9999-9999'}
                                maskHolder={typeSelected.value === '3' ? '(99) 99999-9999' : '(99) 9999-9999'}
                                disabled={!isEditInfos}
                                type='tel'
                                mask
                                register={{ ...register('phoneAdd', { pattern: /^[0-9]{1}$/i }) }}
                            />
                        </Box>
                        <Box sx={{ width: { xs: '100%', md: 'calc(50% - .5rem)' } }}>
                            <Select
                                label='Relacionamento'
                                disabled={!isEditInfos}
                                placeholder='Não especificado'
                                itemSelected={relationshipSelected}
                                listItems={dataRelationship?.map(({ NM_GRAU_RELACIONAMENTO, CD_GRAU_RELACIONAMENTO }) => {
                                    return { text: NM_GRAU_RELACIONAMENTO, value: `${CD_GRAU_RELACIONAMENTO}` }
                                }) || []}
                                onChangeSelected={(e) => setRelationshipSelected(e)}
                            />
                        </Box>
                    </Box>
                </Box>
            </Collapse>

            <Collapse in={!addContact ? !showAddEmergencyContact : !addContact}>
                {dataCustomerForEdit.emergencyList.map(({ contact }, index) => (
                    !watch(`deleted${index}`) &&
                    <Box key={index} sx={{ display: 'flex', position: 'relative', width: '100%', justifyContent: 'flex-start' }} component='form' onSubmit={handleSubmit(onSubmit)}>
                        <Box sx={{ borderTop: `${!addContact ? '2px solid #0C1C33' : ''}`, width: '100%', maxWidth: '35.43rem', '#box-input': { height: '4.125rem' } }}>
                            {!addContact &&
                                <Typography fontSize='1.125rem' color='white' sx={{ padding: '4px .61rem 3px', backgroundColor: 'primary.main', width: 'fit-content', marginBottom: '1rem' }}>
                                    {dataCustomerForEdit.emergencyList.length > 1 ?
                                        `Dado ${index + 1}`
                                        :
                                        'Dado'
                                    }
                                </Typography>
                            }
                            <Box sx={{ display: 'flex', flexDirection: 'column', gap: '1.75rem', marginBottom: '1.75rem' }}>
                                <Input
                                    name={`name${index}`}
                                    label='Nome'
                                    placeholder={`${contact}`}
                                    type='text'
                                    disabled={!isEditInfos}
                                    error={errors[`name${index}`]}
                                    textError="Insira o nome e sobrenome"
                                    register={{ ...register(`name${index}`, { pattern: Regex.name, required: true }) }} />
                                <Box sx={{ display: 'flex', alignItems: 'flex-end', justifyContent: 'space-between', gap: '1rem' }}>
                                    <Select
                                        disabled={!isEditInfos}
                                        label='Tipo'
                                        itemSelected={watch(`typePhone${index}`)}
                                        listItems={DataTypesOfContact.map(({ phoneTypeText, phoneTypeId }) => {
                                            return { text: phoneTypeText, value: `${phoneTypeId}` }
                                        })}
                                        onChangeSelected={(e) => setValue(`typePhone${index}`, e)}
                                    />
                                    <Input
                                        name={`phone${index}`}
                                        label='Telefone'
                                        placeholder={handlePlaceholderPhone(parseFloat(watch(`typePhone${index}[value]`)))}
                                        maskHolder={handlePlaceholderPhone(parseFloat(watch(`typePhone${index}[value]`)))}
                                        disabled={!isEditInfos}
                                        error={errors[`phone${index}`]}
                                        textError="Insira um número válido"
                                        type='tel'
                                        mask
                                        register={{ ...register(`phone${index}`, { pattern: Regex.phone, required: true }) }}
                                    />
                                </Box>
                                <Box sx={{ width: { xs: '100%', md: 'calc(50% - .5rem)' } }}>
                                    <Select
                                        label='Relacionamento'
                                        disabled={!isEditInfos}
                                        placeholder='Não especificado'
                                        itemSelected={watch(`typeContact${index}`)}
                                        listItems={dataRelationship?.map(({ NM_GRAU_RELACIONAMENTO, CD_GRAU_RELACIONAMENTO }) => {
                                            return { text: NM_GRAU_RELACIONAMENTO, value: `${CD_GRAU_RELACIONAMENTO}` }
                                        }) || []}
                                        onChangeSelected={(e) => setValue(`typeContact${index}`, e)}
                                    />
                                </Box>
                            </Box>
                        </Box>
                        {dataCustomerForEdit?.emergencyList?.length > 1 && isEditInfos &&
                            <Box sx={{
                                position: { xs: 'absolute', md: 'relative' },
                                right: '0',
                                top: '-1px',
                                backgroundColor: 'white'
                            }}>
                                <Box sx={{
                                    cursor: 'pointer',
                                    marginLeft: { xs: '.75rem', md: '2rem' },
                                    width: { xs: '2rem', md: '2.5rem' },
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    height: { xs: '2rem', md: '2.5rem' },
                                    borderRadius: '100px',
                                    backgroundColor: 'error.main'
                                }}
                                    onClick={() => setShowModalDeleted({ show: true, indexDeleted: index, })}
                                >
                                    <IcDeleteOutlined />
                                </Box>
                            </Box>
                        }
                    </Box>
                ))}
            </Collapse>

            <Box sx={{ display: 'flex', maxWidth: '35.43rem', gap: '1rem', 'button': { height: '2.5rem', width: '100%', maxWidth: '17.18rem' } }}>
                {(dataCustomerForEdit?.emergencyList?.length > 0 || isEditInfos) &&
                    <ButtonOutlined name={isEditInfos ? 'CANCELAR' : 'Editar'} onClick={() => handleCancelOperation()} />
                }
                <ButtonRectangle name={isEditInfos ? 'SALVAR DADOS' : 'ADICIONAR'} disabled={isEnableBtn} loadingBtn={isLoading} onClick={() => !isEditInfos ? (setAddContact(true), setIsEditInfos(true)) : addContact ? handlePostEditCustomerAppEmergencyContactsState() : handleSubmit(onSubmit)()} />
            </Box>

            <Modals open={showModalDeleted.show}>
                <Box sx={{ textAlign: 'center', width: '23.31rem' }}>
                    <Box sx={{ borderRadius: '8px 8px 0 0' }} padding='1.625rem 0 1.125rem'>
                        <Typography fontSize='1.5625rem' fontWeight={700}>
                            ATENÇÃO!
                        </Typography>
                        <Typography fontSize='.93rem' lineHeight='21px' paddingTop='.875rem'>
                            Deseja remover este contato?
                        </Typography>
                    </Box>
                    <Box sx={{
                        borderRadius: '0 0 8px 8px',
                        padding: '1.875rem 3.81rem 1.75rem',
                        backgroundColor: 'primary.main',
                        'button': {
                            width: '100%',
                            height: '2.5rem',
                        }
                    }}>
                        <ButtonRectangle name='DELETAR' onClick={() => { setValue(`deleted${showModalDeleted.indexDeleted}`, true); setShowModalDeleted({ show: false, indexDeleted: 0, }) }} />
                        <Box sx={{ 'button': { borderColor: '#F9FCFF', color: '#F9FCFF', ':hover': { borderColor: '#F9FCFF', color: '#F9FCFF' } }, marginTop: '.875rem' }}>
                            <ButtonOutlined name='CANCELAR' onClick={() => setShowModalDeleted({ show: false, indexDeleted: 0, })} />
                        </Box>
                    </Box>
                </Box>
            </Modals>
        </Box>
    );
}

export default EmergencyContact;